
"use strict"

// styles

import 'aos/dist/aos.css'

// polyfills

import objectFitImages from 'object-fit-images'


// components 

import carousel from './components/hero-carousel'
import programmeCarousel from './components/programme-carousel'
import bmNav from './components/bm-nav'
import videoLightbox from './components/videoLightbox'
import AOS from 'aos';
import successCarousel from './components/success-carousel'
import iconCarousel from './components/icon-content-carousel'
import expand from './components/expand'
import findRoute from './components/find-your-route'
import lawInEnglish from './components/law-in-english'
import eventsFilter from './components/events-filter'
import instagramFooter from './components/instagram-footer'


// init

objectFitImages()
carousel()
programmeCarousel()
videoLightbox()
successCarousel()
iconCarousel()
findRoute()
lawInEnglish()
eventsFilter()
instagramFooter()


// register AOS

AOS.init({
    once: true, // whether animation should happen only once - while scrolling down
    anchorPlacement: 'bottom', // defines which position of the element regarding to window should trigger the animation
    duration: 500,
});


// accordion

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})


document.documentElement.classList.remove('no-js')
document.documentElement.classList.add('js')